import * as React from "react";
import { Chip, type ChipProps } from "@mui/material";

interface PositionBadgeProps {
  status: string | null | undefined;
}

const COLOR_MAP: Record<string, ChipProps["color"]> = {
  filled: "success",
  closed: "success",
  open: "info",
  pending: "warning",
  submitted: "warning",
  partially_filled: "warning",
  cancelled: "default",
  rejected: "error",
  failed: "error",
};

/** Maps a backend-reported order/position status string to a colored chip — displays the exact string, never a derived state. */
export function PositionBadge({ status }: PositionBadgeProps): React.JSX.Element {
  const normalized = (status ?? "unknown").toLowerCase();
  const color = COLOR_MAP[normalized] ?? "default";
  return <Chip size="small" label={status ?? "unknown"} color={color} variant="outlined" />;
}
